import { __assign } from "tslib";
// @ts-expect-error
import { permissionsChecker as permissionsCheckerFactory } from '@wix/communities-forum-universal/dist/src/services/permissions/forum-permission-checker';
var resourcify = function (entity, resourceType) {
    return __assign(__assign({}, (entity || {})), { getResourceId: function () { return resourceType; } });
};
var createPermissionsChecker = function (permissions) { return function (permission, resourceType, entity) {
    return permissions.can(resourcify(entity, resourceType), permission);
}; };
var createPermissionsRenderHelper = function (canChecker) { return function (checks, render) {
    var result = checks.map(function (_a) {
        var permission = _a[0], resource = _a[1], obj = _a[2];
        switch (resource) {
            case 'forum':
                return canChecker(permission, 'forum', obj);
            case 'category':
                return canChecker(permission, 'category', obj);
            case 'post':
                return canChecker(permission, 'post', obj);
            case 'comment':
                return canChecker(permission, 'comment', obj);
            case 'mobileSettings':
                return canChecker(permission, 'mobileSettings', obj);
            default:
                throw new Error("Unknown resource '".concat(resource, "' for permission '").concat(permission, "' in permissions checker"));
        }
    });
    var can = result.some(function (r) { return r; });
    return can ? render(result) : null;
}; };
var getUserSiteMemberId = function (user) {
    if (user && user.siteMemberId) {
        return { siteMemberId: user.siteMemberId };
    }
    if (user && user.id) {
        return { siteMemberId: user.id };
    }
    return {};
};
var userToRequestor = function (user, permissions) {
    var publicUserPrivateStatuses = ['PUBLIC', 'COMMUNITY'];
    var isPublicUser = user && publicUserPrivateStatuses.includes(user.privacyStatus);
    return __assign(__assign({ permissions: permissions, groups: user && user.groups ? user.groups : [], type: isPublicUser ? 'MEMBER' : 'GUEST' }, getUserSiteMemberId(user)), (user && user.userId && { userId: user.userId }));
};
var categoryResolver = function (resolveCategory) { return function (resource) {
    if (resource.categoryId) {
        resource = resolveCategory(resource.categoryId);
    }
    return resource;
}; };
var permissionsChecker = permissionsCheckerFactory();
export var createPermissionCheckerClientAPI = function (_a) {
    var user = _a.user, usersPermissions = _a.usersPermissions, getCategory = _a.getCategory;
    var requestor = userToRequestor(user, usersPermissions);
    var permissions = permissionsChecker.withContext(requestor, categoryResolver(getCategory));
    var canPermissionsHelper = createPermissionsChecker(permissions);
    var permissionsRenderHelper = createPermissionsRenderHelper(canPermissionsHelper);
    return {
        permissions: permissions,
        can: canPermissionsHelper,
        canRender: permissionsRenderHelper,
    };
};
//# sourceMappingURL=permission-checker-client-api.js.map